export const valorantApiUrl = process.env.REACT_APP_VALORANT_API_URL;
export const overwatchApiUrl = process.env.REACT_APP_OVERWATCH_API_URL;
export const r6ApiUrl = process.env.REACT_APP_R6_API_URL;
